// import one from '../assets/svg/projects/one.svg'
// import two from '../assets/svg/projects/two.svg'
// import three from '../assets/svg/projects/three.svg'
// import four from '../assets/svg/projects/four.svg'
// import five from '../assets/svg/projects/five.svg'
// import six from '../assets/svg/projects/six.svg'
// import seven from '../assets/svg/projects/seven.svg'
// import eight from '../assets/svg/projects/eight.svg'
import uniqlohomepage from './uniqlohomepage.png'
import chatApp from './chatApp.png'
import food from './food.png'
import movie from './movie.png'
import weather from './weather.png'
import youtube from './youtube.png'
import ecom from '../assets/png/ecom.png'
import tic from './tic-tac-toe.png';
import invImage from './investmentImage.png';
export const projectsData = [
    {
        id: 0,
        projectName: 'Chat-App',
        projectDesc: 'A chat application where multiple users can chat by joining a chat-room.',
        tags: ['React', 'NodeJs', 'Express', 'Socket.IO'],
        code: 'https://github.com/sudhanshu7352/Chat-Application',
        demo: 'https://chat-application-ten-rho.vercel.app',
        image: chatApp
    },
    {
        id: 1,
        projectName: 'Tic-Tac-Toe',
        projectDesc: 'This project is a simple Tic-Tac-Toe game built with ReactJS. Players take turns marking squares on a 3x3 grid, aiming to form a horizontal, vertical, or diagonal line of their mark (X or O).',
        tags: ['React', 'CSS'],
        code: 'https://github.com/sudhanshu7352/Tic-Tac-Toe-react',
        demo: 'https://tic-tac-toe-react-mocha.vercel.app/',
        image: tic
    },
    {
        id: 2,
        projectName: 'Investment-Calculator',
        projectDesc: 'A web application where user can check their capital grow each year.',
        tags: ['HTML', 'CSS', 'React'],
        code: 'https://github.com/sudhanshu7352/Investment-Calculator-React',
        demo: 'https://investment-calculator-react-orcin.vercel.app/',
        image: invImage
    },
    {
        id: 3,
        projectName: 'E-commerce site',
        projectDesc: 'A web application for ordering cloth,electronics,books etc.. ',
        tags: ['REACT', 'REDUX', 'NODEJS'],
        code: 'https://github.com/masai-course/sudhanshu_fw14_091/tree/master/E-commerce%20website',
        demo: 'https://e-com-site.vercel.app',
        image: ecom
    },
    {
        id: 6,
        projectName: 'Weather app',
        projectDesc: 'A simple app to find weather and temperature of any city',
        tags: ['HTML', 'CSS', 'JavaScript'],
        code: 'https://github.com/sudhanshu7352/weather-mini-app-.git',
        demo: 'https://sudhanshu7352.github.io/weather-mini-app-/',
        image: weather
    },
    {
        id: 4,
        projectName: 'Food-receipe-app',
        projectDesc: 'A application for finding a receipe by searching from input box',
        tags: ['HTML', 'CSS', 'JavaScript'],
        code: 'https://github.com/sudhanshu7352/mini-food-app.git',
        demo: 'https://mini-food-app.vercel.app/',
        image: food
    },
    {
        id: 5,
        projectName: 'Movie-info App',
        projectDesc: 'A Simple  application to get information about any movie',
        tags: ['HTML', 'CSS', 'JavaScript'],
        code: 'https://github.com/sudhanshu7352/movie-info-app.git',
        demo: 'https://sudhanshu7352.github.io/movie-info-app/',
        image: movie
    },
    {
        id: 7,
        projectName: 'Youtube mini clone',
        projectDesc: 'A simple app to search and watch youtube videos',
        tags: ['HTML', 'CSS', 'JavaScript'],
        code: 'https://github.com/sudhanshu7352/Youtube--mini-Clone.git',
        demo: 'https://sudhanshu7352.github.io/Youtube--mini-Clone/',
        image: youtube
    },
    // {
    //     id: 8,
    //     projectName: 'Car Pooling System',
    //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
    //     tags: ['Flutter', 'React'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: eight
    // },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/